import React, { FC, useState, useEffect } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import { AutoCoderCode } from '../../types/gotypes'

interface ThemeEditModalProps {
  open: boolean
  mode: 'add' | 'edit'
  initialTheme?: AutoCoderCode
  onCancel: () => void
  onSave: (theme: AutoCoderCode) => void
}

const ThemeEditModal: FC<ThemeEditModalProps> = ({
  open,
  mode,
  initialTheme,
  onCancel,
  onSave,
}) => {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')

  useEffect(() => {
    if (open) {
      setName(initialTheme?.text || '')
      setDescription(initialTheme?.description || '')
    }
  }, [open, initialTheme])

  const handleSave = () => {
    const trimmedName = name.trim()
    if (!trimmedName) return

    onSave({
      code: trimmedName,
      text: trimmedName,
      description: description.trim(),
    })
  }

  const canSave = name.trim().length > 0

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>{mode === 'add' ? 'Add Theme' : 'Edit Theme'}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            label="Theme Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            fullWidth
            autoFocus
            required
            placeholder="Enter theme name..."
          />
          <TextField
            label="Description (for LLM guidance)"
            multiline
            rows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            placeholder="Describe when this theme should be applied..."
            helperText="This description helps the AI decide when to apply this theme to text data"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="info" disabled={!canSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ThemeEditModal
